(function () {
  function fixOkendoThumbnailAlt() {
    document.querySelectorAll('a[aria-hidden="true"] img.oke-product-thumbnail-image[alt]:not([alt=""])').forEach(function (img) {
      img.setAttribute('alt', '');
    });
  }

  function shortenOkendoMediaAlt(text) {
    var match = /the image represents:\s*([\s\S]+)$/i.exec(text);
    var result = match ? match[1] : text;
    return result
      .replace(/^customer-uploaded image\.?\s*/i, '')
      .replace(/click to see more details\.?\s*/i, '')
      .trim();
  }

  function fixOkendoMediaAlt() {
    document.querySelectorAll('.oke-media-link img.oke-media-image[alt]').forEach(function (img) {
      var current = img.getAttribute('alt');
      var shortened = shortenOkendoMediaAlt(current);
      if (shortened && shortened !== current) {
        img.setAttribute('alt', shortened);
      }
    });

    document.querySelectorAll('.oke-media-link[aria-label]').forEach(function (btn) {
      var current = btn.getAttribute('aria-label');
      var shortened = shortenOkendoMediaAlt(current);
      if (shortened && shortened !== current) {
        btn.setAttribute('aria-label', shortened);
      }
    });
  }

  function fixOkendoA11y() {
    fixOkendoThumbnailAlt();
    fixOkendoMediaAlt();
  }

  var observer = new MutationObserver(fixOkendoA11y);
  observer.observe(document.body, { childList: true, subtree: true });
  fixOkendoA11y();
})();
